<template>
   <div class="key-advantage">
      <img :src="require(`../../../assets/pages/main/${icon}.svg`)">
      <h3>{{title}}</h3>
      <p>
         <slot></slot>
      </p>
   </div>
</template>

<script>
    export default {
        name: "MainPageKeyAdvantage",
        props: ['title', 'icon']
    }
</script>

<style scoped lang="scss">
   @import "../../../theme/theme";

   .key-advantage {
      display: grid;
      grid-template-rows: auto 2em auto;

      h3 {
         justify-self: center;
         text-align: center;
         font-size: 1.5rem;
         font-weight: 300;
         color: $text80;
      }

      p {
         margin-top: 2em;
         justify-self: center;
         font-size: 1rem;
         font-weight: 300;
         text-align: justify;
         max-width: 25em;
         color: $text100;
      }

      img {
         width: 100%;
         height: auto;
         max-height: 10rem;
         padding: 0 20% 0 20%;
      }
   }
</style>